import script from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=02158dcc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bob-web/bob-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02158dcc"]])

export default __exports__